export const domReady = (loading: () => void, loaded: () => void) => {
  if (document.readyState === 'complete') {
    loaded()
  } else {
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'interactive') {
        loading()
      }
      if (document.readyState === 'complete') {
        loaded()
      }
    }, false)
  }
}
